export const getnum = (num)=>{
	num = parseFloat(num)
	if(isNaN(num)){
		return 0
	}else{
		return num
	}
}

export const add = (arr)=>{
	let sum = arr.reduce((total,item)=>{
		return total + getnum(item)
	},0)
	return sum.toFixed(2)
}

export const cheng = (arr)=>{
	let sum = arr.reduce((total,item)=>{
		return total * getnum(item)
	},1)
	return sum.toFixed(2)
}

export const chu = (num1,num2)=>{
	let ret = getnum(num1)/getnum(num2)
	return ret.toFixed(2)
}

export const jian = (num1,num2)=>{
	let ret = getnum(num1)-getnum(num2)
	return ret.toFixed(2)
}

